module.exports = __webpack_public_path__ + "static/media/Tallet.55457263.mp3";